/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { practiceTypeIdGet } from '../fn/practice-type/practice-type-id-get';
import { PracticeTypeIdGet$Params } from '../fn/practice-type/practice-type-id-get';
import { PracticeTypeModel } from '../models/practice-type-model';
import { PracticeTypeModelSearchResultModel } from '../models/practice-type-model-search-result-model';
import { practiceTypePost } from '../fn/practice-type/practice-type-post';
import { PracticeTypePost$Params } from '../fn/practice-type/practice-type-post';
import { practiceTypeSearchPracticeTypePost } from '../fn/practice-type/practice-type-search-practice-type-post';
import { PracticeTypeSearchPracticeTypePost$Params } from '../fn/practice-type/practice-type-search-practice-type-post';

@Injectable({ providedIn: 'root' })
export class MDIPracticeTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `practiceTypeSearchPracticeTypePost()` */
  static readonly PracticeTypeSearchPracticeTypePostPath = '/PracticeType/SearchPracticeType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practiceTypeSearchPracticeTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practiceTypeSearchPracticeTypePost$Response(params?: PracticeTypeSearchPracticeTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PracticeTypeModelSearchResultModel>> {
    return practiceTypeSearchPracticeTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practiceTypeSearchPracticeTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practiceTypeSearchPracticeTypePost(params?: PracticeTypeSearchPracticeTypePost$Params, context?: HttpContext): Observable<PracticeTypeModelSearchResultModel> {
    return this.practiceTypeSearchPracticeTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<PracticeTypeModelSearchResultModel>): PracticeTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `practiceTypeIdGet()` */
  static readonly PracticeTypeIdGetPath = '/PracticeType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practiceTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  practiceTypeIdGet$Response(params: PracticeTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PracticeTypeModel>> {
    return practiceTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practiceTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  practiceTypeIdGet(params: PracticeTypeIdGet$Params, context?: HttpContext): Observable<PracticeTypeModel> {
    return this.practiceTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<PracticeTypeModel>): PracticeTypeModel => r.body)
    );
  }

  /** Path part for operation `practiceTypePost()` */
  static readonly PracticeTypePostPath = '/PracticeType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `practiceTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practiceTypePost$Response(params?: PracticeTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return practiceTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `practiceTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  practiceTypePost(params?: PracticeTypePost$Params, context?: HttpContext): Observable<string> {
    return this.practiceTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
